/**
 * Le pays gouverné par le joueur — nommé symboliquement, comme les pays
 * voisins caricaturaux (« Le Tsarat », « Le Dragon Rouge »…), pour évoquer
 * la France sans jamais la nommer. Source unique de vérité du nom et de ses
 * formes dérivées (gentilé, adjectif) pour la prose générée et la carte.
 *
 * Note : les noms propres d'institutions réelles (Banque de France, France
 * Travail, équipe de France…) gardent leur nom — c'est la texture crédible
 * du jeu ; seule la NATION en tant qu'entité prend le nom symbolique.
 */
export const HOME_COUNTRY = {
  /** Forme courante, en milieu de phrase. */
  label: "l'Hexagone",
  /** Forme en tête de phrase (article élidé majuscule). */
  labelCap: "L'Hexagone",
  /** Gentilé pluriel : « les Hexagonaux ». */
  demonym: "Hexagonaux",
  /** Gentilé singulier / adjectif masculin : « un Hexagonal », « le rail hexagonal ». */
  adjective: "hexagonal",
} as const;
